<template src="../templates/normal_fcont_133.html" />
<script>
import LabelFunMessage from '../components/LabelFunMessage'

import FuncSearchGalleryQR from '../components/FuncSearchGalleryQR'
import PrintButton from '../components/PrintButton'
import UseDesignPaperList from '../components/UseDesignPaperList'
import FuncSearchRecommendLink from '../components/FuncSearchRecommendLink';
import InfoMachineTranslation from '../components/InfoMachineTranslation'
import AppDownloadCreative from '../components/AppDownloadCreative'
import { Carousel,Slide } from 'uiv'

export default {
  name: 'app',
  components: {
    LabelFunMessage, Carousel,Slide,FuncSearchRecommendLink,
    FuncSearchGalleryQR,PrintButton,UseDesignPaperList,
    InfoMachineTranslation,AppDownloadCreative
  },
  data() {
    return {
      app_root: process.env.VUE_APP_ROOT
    }
  },
  metaInfo() {
    return {
      title: this.$store.state.messages.messages['133-1'],
    meta: [
      { name: 'description', content: this.$store.state.messages.messages['133-2']}
    ]};
  }
  
};
</script>
<style >
</style>

